<template>
  <div style="overflow: hidden;">
    <scroll-animation-unit class="p-pickup u-fade">
      <div v-show="!lte3" class="prev">prev</div>

      <div class="p-pickup__content" ref="content">
        <slick 
          ref="slickPc" 
          :options="slickOptionsPc" 
          class="p-pickup__list"
          @init="onInit">
          <div class="p-pickup__slide" v-for="(item, i) in items">
            <pickup-item :item="item" />
          </div>
        </slick>  
      </div>
      
      

      <div class="p-pickup__carousel">
        <div class="p-container">
          <slick
            ref="slick"
            :options="slickOptions">

            <div v-for="item in items" class="p-pickup__item" :class="{
              'has-link': item.pickup_link ? true : false
            }">
              <a :href="item.pickup_link" class="p-pickup__link" target="_blank">
                <div class="p-pickup__image">
                  <img :src="item.pickup_image.url" :alt="item.pickup_image.title" class="u-cover">
                  <span class="p-pickup__type" v-text="item.pickup_type"></span>
                </div>
                <dl class="p-pickup__description">
                  <dt>
                    <em v-if="item.pickup_link">{{ item.pickup_title }}<i class="icon-external"></i></em>
                    <span v-else v-text="item.pickup_title"></span>
                  </dt>
                  <dd v-html="item.pickup_lead"></dd>
                </dl>
              </a>
              <div v-if="item.pickup_map_url" class="p-pickup__mapUrl">
                <a :href="item.pickup_map_url" target="_blank" class="c-externalLink" data-type="map"><i class="icon-access"></i>Open Google Map</a>
              </div>
            </div>
          </slick>
        </div>
      </div>
    </scroll-animation-unit>  
  </div>
</template>

<script>
  import Slick from 'vue-slick';
  import PickupItem from '~/partial/pickup-item';

  /**
   * Share Partial
   */

  export default {
    name: 'pickup',
    components: {
      Slick,
      PickupItem
    },
    props: {
      items: {
        type: Array
      }
    },
    data() {
      return {
        isHovered: false,
        slickOptionsPc: {
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          slidesToShow: 3,
          speed: 1200,
          prevArrow: '.prev',
          dots: true,
        },
        slickOptions: {
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          slidesToShow: 4,
          speed: 1200,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '44px',
              }
            },
          ]
        }
      }
    },
    computed: {
      lte3() {
        return this.items.length <= 3
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      onInit() {
        if(this.items.length <= 2) {
          setTimeout(() => {
            this.$refs.content.querySelector('.slick-track').style.width = 'auto'
          }, 2000)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/cominca-pickup.vue